var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "list", attrs: { id: "list" } },
    [
      _c(
        "draggable",
        {
          attrs: {
            group: "group",
            "force-fallback": true,
            "ghost-class": "sortable__ghost",
          },
          on: { change: _vm.sortViolationGroups },
          model: {
            value: _vm.violationGroupsList,
            callback: function ($$v) {
              _vm.violationGroupsList = $$v
            },
            expression: "violationGroupsList",
          },
        },
        _vm._l(_vm.violationGroupsList, function (group) {
          return _c("violation-types-list-group", {
            directives: [
              {
                name: "observe-visibility",
                rawName: "v-observe-visibility",
                value: _vm.categoryVisibleChange,
                expression: "categoryVisibleChange",
              },
            ],
            key: group.id,
            attrs: {
              "selected-list-group-items-status":
                _vm.selectedListGroupItemsStatus,
              "sticky-category-id": _vm.stickyCategoryId,
              "list-group": group,
              filters: _vm.filters,
            },
            on: {
              "on-delete-list-group-item": function ($event) {
                return _vm.$emit("on-delete-list-group-item")
              },
              "on-delete-list-group": function ($event) {
                return _vm.$emit("on-delete-list-group")
              },
              "edit-group": function ($event) {
                return _vm.$emit("edit-group", $event)
              },
              "edit-list-group-item": function ($event) {
                return _vm.$emit("edit-list-group-item", $event)
              },
            },
          })
        }),
        1
      ),
      _c(
        "div",
        { staticClass: "reference-violation-types__list__without-group" },
        [
          _c(
            "draggable",
            {
              attrs: {
                group: "type",
                "force-fallback": true,
                "ghost-class": "sortable__ghost",
              },
              on: { change: _vm.onSort },
              model: {
                value: _vm.violationList,
                callback: function ($$v) {
                  _vm.violationList = $$v
                },
                expression: "violationList",
              },
            },
            _vm._l(_vm.violationList, function (listGroupItem) {
              return _c("violation-types-list-group-item", {
                key: listGroupItem.id,
                attrs: {
                  "list-group-item": listGroupItem,
                  "selected-list-group-items-status":
                    _vm.selectedListGroupItemsStatus,
                },
                on: {
                  "on-delete-list-group-item": function ($event) {
                    return _vm.$emit("on-delete-list-group-item")
                  },
                  "edit-list-group-item": function ($event) {
                    return _vm.$emit("edit-list-group-item", $event)
                  },
                },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }